// extracted by mini-css-extract-plugin
module.exports = {"Badge":"HelperTooltip_Badge__rX5Tf"};